import { FC, useEffect, useState } from "react"
import { AdminFormFieldInput, AdminFormFieldSubmit } from "../../../../components/admin/formFields";
import { useTranslation } from "react-i18next";
import AddMaintenanceDetails from "./addMaintenanceDetails";
import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../../../api/store/commonSlice";
import { formattedDateTime } from "../../../../utils/dateTime";

interface MaintenanceFormProps {
  label: string;
  maintenanceTypeId: string;
  serviceIntervalId: string,
  notificationWindowId: string,
  values: any;
  errors: any;
  touched: any;
  handleChange: (event: React.ChangeEvent<any>) => void;
  formikSetValue: (field: string, value: any, shouldValidate?: boolean) => void;
  handleBlur: (event: React.FocusEvent<any>) => void;
  formikSetTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
  userCanEdit: boolean;
  loadingData: boolean;
}

export const MaintenancePerodicInputForm: FC<MaintenanceFormProps> = ({
  label,
  maintenanceTypeId,
  serviceIntervalId,
  notificationWindowId,
  values,
  errors,
  touched,
  handleChange,
  formikSetValue,
  handleBlur,
  formikSetTouched,
  userCanEdit,
  loadingData
}) => {
  const { t } = useTranslation("translation", { keyPrefix: "admins.maintenance.detailsPage.form" });
  const dispatch = useDispatch();
  const modalsState = useSelector((state: { commonReducer: { modals: TModalsState } }) => state.commonReducer.modals);

  return (
    <>
      <AdminFormFieldInput
        label={label}
        type="date-picker"
        id={maintenanceTypeId}
        name={maintenanceTypeId}
        placeholder="Enter the date"
        value={values?.[maintenanceTypeId] ? formattedDateTime(values?.[maintenanceTypeId], 'yyyy-MM-dd') : undefined}
        onDatepickerChange={(_,value) => {
          formikSetValue(maintenanceTypeId,formattedDateTime(value, 'yyyy-MM-dd'));
        }}
        onBlur={(e) => {
          formikSetTouched(maintenanceTypeId, true);
          handleBlur(e);
        }}
        touched={touched?.[maintenanceTypeId]}
        error={errors?.[maintenanceTypeId]}
        disabled={!userCanEdit}
        detailsFormField={true}
        customWrapperClass="col-span-4"
        size="lg"
      />


      <AdminFormFieldInput
        label={t('service_interval')}
        type="text"
        id={serviceIntervalId}
        name={serviceIntervalId}
        bottomLabel={"in Months"}
        value={values?.[serviceIntervalId]}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched?.[serviceIntervalId]}
        error={errors?.[serviceIntervalId]}
        disabled={!userCanEdit}
        detailsFormField={true}
        customWrapperClass="col-span-4"
      />

      <AdminFormFieldInput
        label={t('notification_window')}
        type="text"
        id={notificationWindowId}
        name={notificationWindowId}
        bottomLabel={"in Days"}
        value={values?.[notificationWindowId]}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched?.[notificationWindowId]}
        error={errors?.[notificationWindowId]}
        disabled={!userCanEdit}
        detailsFormField={true}
        customWrapperClass="col-span-4"
      />
    </>
  )
}